import { render } from "./PersonCard.vue?vue&type=template&id=2b133ae8&scoped=true&ts=true"
import script from "./PersonCard.vue?vue&type=script&lang=ts"
export * from "./PersonCard.vue?vue&type=script&lang=ts"

import "./PersonCard.vue?vue&type=style&index=0&id=2b133ae8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b133ae8"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCheckbox,QAvatar,QImg,QIcon,QCardSection,QTooltip,QCardActions,QBtn});
